// extracted by mini-css-extract-plugin
export default {"root":"D9w360qbFb","list":"okBO__Pwvl"};